import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { PinAuthService } from '../services/auth/pin-auth.service';

/**
 * Гуард, который проверяет, установлен ли пин-код.
 * Применяется только для вошедших пользователей: если пользователь не авторизован
 * (нет валидного токена), пин-код не требуется и доступ разрешается.
 * Если пользователь авторизован, но пин-код не установлен - перенаправляет на страницу настройки пин-кода.
 */
export const pinSetGuard: CanActivateFn = async () => {
  const oauthService = inject(OAuthService);
  const pinAuthService = inject(PinAuthService);
  const router = inject(Router);

  if (!oauthService.hasValidAccessToken()) {
    return true;
  }

  const isPinSet = await pinAuthService.isPinSet();

  if (!isPinSet) {
    return router.createUrlTree(['/pin-setup']);
  }

  return true;
};
